import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Waivers = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Waivers | Son's Island</title>
        <meta name="description" content="Complete your waiver for Son's Island activities. Sign your liability waiver before your visit." />
      </Helmet>

      {/* Header */}
      <div className="bg-primary/10 py-8">
        <div className="container mx-auto px-4 text-center">
          <Link to="/" className="inline-block">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground">Liability Waiver</h1>
          <p className="text-muted-foreground mt-2">Everyone MUST sign to enter the properties.</p>
        </div>
      </div>

      {/* Widget Container */}
      <div className="container mx-auto px-4 py-8">
        <iframe
          name="checkfront"
          className="CHECKFRONT_DROPLET"
          src="https://sonsguadalupe.checkfront.com/reserve/document/?template_id=1&return_url=%2Freserve%2Fdocuments%2Fdirectory%2F&kiosk=1/?inline=1&provider=droplet&pipe=https%3A%2F%2Fsonsguadalupe.checkfront.com%2Fmanage%2Fextend%2Fintegrate%2Fwidget%2Fdroplet%2Fpipe%2Fhelper.html&ssl=1&src=https%3A%2F%2Fsonsguadalupe.checkfront.com"
          frameBorder="0"
          scrolling="yes"
          style={{
            height: '13500px',
            display: 'block',
            minHeight: '60px',
            overflow: 'hidden',
            transition: 'height 200ms ease-out 0s',
            width: '1px',
            minWidth: '100%'
          }}
          title="Waiver Form"
        />
      </div>
    </div>
  );
};

export default Waivers;
